import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import upIcon from '../../../images/icons/up.svg';
import CollapseDispatch from '../../../contexts/collapseDispatch';
import collapseActions from '../../../actions/collapse.actions';

import style from './ClientPanelCardHeader.module.css';

const ClientPanelCardHeader = React.memo(
  ({ title, collapsed = false, forCard, img }) => {
    const dispatch = useContext(CollapseDispatch);

    const handleCollapse = event => {
      event.preventDefault();

      switch (forCard) {
        case 'contacts':
          dispatch({
            type: collapseActions.CONTACTS_COLLAPSE_SUCCESS,
          });
          break;
        case 'addresses':
          dispatch({
            type: collapseActions.ADDRESSES_COLLAPSE_SUCCESS,
          });
          break;
        case 'assignments':
          dispatch({
            type: collapseActions.ASSIGNMENTS_COLLAPSE_SUCCESS,
          });
          break;
        case 'underwriting':
          dispatch({
            type: collapseActions.UNDERWRITING_COLLAPSE_SUCCESS,
          });
          break;
        default:
          break;
      }
    };

    return (
      <div className={style.main}>
        <div>
          <img src={img} alt="" />
          <span>{title}</span>
        </div>
        <a
          onClick={handleCollapse}
          href="/collapse"
          className={`${collapsed && style.collapsed}`}
        >
          <img src={upIcon} alt="" />
        </a>
      </div>
    );
  },
);

ClientPanelCardHeader.propTypes = {
  title: PropTypes.string.isRequired,
  collapsed: PropTypes.bool,
  forCard: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
};

export default ClientPanelCardHeader;
